import memberstackDOM from '@memberstack/dom';

const memberstack = memberstackDOM.init({
  publicKey: "pk_d1b24192bf8e0b88ed91",
});

export default memberstack;
